import Swiper from 'swiper/dist/js/swiper.min';

export default class Gallery {
  constructor(parent) {
    this.gallery = parent;
    const self = this;
    this.sliderBtnsWrp = this.gallery.querySelector('.gallery__slider-buttons');
    const sliderBtns = [].slice.call(this.gallery.querySelectorAll('.sliderButtons__btn'));
    const sliderNav = this.gallery.querySelector('.gallery__tab-btns');
    if (sliderNav) {
      const sliderNavBtns = [].slice.call(this.gallery.querySelectorAll('.gallery__tab-btn'));
      const navSlider = {
        instance: null,
        options: {
          slidesPerView: 'auto',
          resistance: true,
          resistanceRatio: 0,
          freeMode: true,
        },
        init() {
          this.instance = new Swiper(sliderNav, this.options);
        },
      };
      if (sliderNavBtns && sliderNavBtns.length > 3) {
        navSlider.init();
      }
    }


    this.thumbSlider = {
      options: {
        slidesPerView: 'auto',
        resistance: true,
        resistanceRatio: 0,
        freeMode: true,
        spaceBetween: 8,
        on: {
          init() {
            const slides = [].slice.call(this.slides);

            slides.forEach((slide, index) => {
              slide.classList.remove('gallery__thumb-slide--active');
              if (index === 0) {
                slide.classList.add('gallery__thumb-slide--active');
              }

              slide.addEventListener('click', (e) => {
                e.preventDefault();

                slides.forEach(tmp => tmp.classList.remove('gallery__thumb-slide--active'));
                slide.classList.add('gallery__thumb-slide--active');

                if (self.mainSlider.instance) {
                  self.mainSlider.instance.slideToLoop(index);
                }
              });
            });
          },
        },
        breakpoints: {
          1023: {
            spaceBetween: 7,
          },
        },
      },
      instance: undefined,
    };

    this.mainSlider = {
      options: {
        slidesPerView: 1,
        resistance: true,
        resistanceRatio: 0,
        spaceBetween: 20,
        preloadImages: false,
        lazy: {
          loadPrevNext: false,
        },
        loop: true,
        navigation: {
          prevEl: sliderBtns[0],
          nextEl: sliderBtns[1],
        },
        on: {
          slideChange() {
            if (self.thumbSlider !== undefined) {
              const slides = [].slice.call(self.thumbSlider.instance.slides);
              slides.forEach(tmp => tmp.classList.remove('gallery__thumb-slide--active'));
              slides[this.realIndex].classList.add('gallery__thumb-slide--active');
              self.thumbSlider.instance.slideTo(this.realIndex);
            }
          },
        },
      },
      instance: undefined,
    };

    const galleryTabs = [].slice.call(this.gallery.querySelectorAll('.gallery__tab'));

    if (galleryTabs.length > 1) {
      const tabBtns = [].slice.call(this.gallery.querySelectorAll('.gallery__tab-btns input'));

      if (tabBtns.length !== 0) {
        tabBtns.forEach((btn, index) => {
          btn.addEventListener('change', () => {
            galleryTabs.forEach(tmp => tmp.classList.remove('gallery__tab--active'));

            galleryTabs[index].classList.add('gallery__tab--active');
            this.slidersInit(galleryTabs[index]);
          });
        });
      }
    }

    this.slidersInit(galleryTabs[0]);
  }

  slidersInit(tab) {
    const mainSliderWrp = tab.querySelector('.gallery__main-slider');
    const thumbSliderWrp = tab.querySelector('.gallery__thumb-slider');
    const mainSlides = [].slice.call(mainSliderWrp.querySelectorAll('.gallery__main-slide'));

    if (this.mainSlider.instance && this.thumbSlider.instance) {
      this.mainSlider.instance.destroy(true, true);
      this.thumbSlider.instance.destroy(true, true);
    }

    if (mainSlides.length > 1) {
      this.thumbSlider.instance = new Swiper(thumbSliderWrp, this.thumbSlider.options);
      this.mainSlider.instance = new Swiper(mainSliderWrp, this.mainSlider.options);
      thumbSliderWrp.style.display = '';
      this.sliderBtnsWrp.style.display = '';
    } else {
      thumbSliderWrp.style.display = 'none';
      this.sliderBtnsWrp.style.display = 'none';
    }
  }
}



// WEBPACK FOOTER //
// ./blocks/gallery/gallery.js